﻿
if (document.getElementsByClassName("dealer-search-button").length) {
    document.querySelector(".dealer-search-button").addEventListener("click", executeDealerSearch);
}

if (document.getElementsByClassName("dealer-search-location-button").length) {
    document.querySelector(".dealer-search-location-button").addEventListener("click", executeLocationSearch);
}

function executeDealerSearch() {
    let searchPhrase = document.getElementById("searchQuery").value;
    //let searchCountry = 
    //let searchState = 


    fetch("/umbraco/surface/DealerSearcher/Search/?query=" + searchPhrase)
        .then(response => {
            response.text()
                .then(html => {
                    document.getElementById("search-results").innerHTML = html;

                    toggleSearchResult();

                    // Vis/skjul mer/mindre pr forhandler i resultatlisten
                    //if (document.getElementsByClassName("dealer-search-show-more").length) {
                    //    document.querySelector(".dealer-search-show-more").addEventListener("click", toggleDealer);
                    //}
                });
        });
}

function executeDealerSearch() {
    let resultContainer = document.getElementById("search-results");

    if (navigator.geolocation) {
        let location = navigator.geolocation.getCurrentPosition();
        
        fetch("/umbraco/surface/DealerSearcher/SearchLocation/?lat=" +
                location.coords.latitude +
                "&lng=" +
                location.coords.longitude)
            .then(response => {
                response.text()
                    .then(html => {
                        resultContainer.innerHTML = html;

                        toggleSearchResult();

                        // Vis/skjul mer/mindre pr forhandler i resultatlisten
                        //if (document.getElementsByClassName("dealer-search-show-more").length) {
                        //    document.querySelector(".dealer-search-show-more").addEventListener("click", toggleDealer);
                        //}
                    });
            });
    } else {
        resultContainer.innerHTML = "<span>Lokasjonstjenesten er ikke tilgjengelig.</span>";
    }
}

function toggleSearchResult() {
    debugger;
    let resultDiv = document.getElementById("dealer-search-results");
    if (resultDiv.style.display === "none") {
        resultDiv.style.display = "block";
    } else {
        resultDiv.style.display = "none";
    }
}

function toggleDealer(evt) {
    let id = evt.currentTarget.attributes["data-model-id"].value;

    let dealerCardDiv = document.getElementById(id);
    if (dealerCardDiv.style.display === "none") {
        dealerCardDiv.style.display = "block";
    } else {
        dealerCardDiv.style.display = "none";
    }
}